import { render, staticRenderFns } from "./StudentTopPage.vue?vue&type=template&id=72dbfea8&scoped=true"
import script from "./StudentTopPage.vue?vue&type=script&lang=js"
export * from "./StudentTopPage.vue?vue&type=script&lang=js"
import style0 from "./StudentTopPage.vue?vue&type=style&index=0&id=72dbfea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dbfea8",
  null
  
)

export default component.exports